<template>
  <div>
    <v-card>
      <v-layout>
        <v-flex>
          <h2>Reporte Varillas CE y pH</h2>
        </v-flex>
        <v-flex>
          <v-select
            :items="subprojects"
            name="name"
            item-text="name"
            label="Rancho"
            @change="selectSubproject($event)"
          />
        </v-flex>
      </v-layout>
    </v-card>

    <br />

    <v-dialog v-model="dialog">
      <v-card>
        <h2>
          {{ rancho }}
        </h2>
        <br />

        <v-data-table
          :headers="headers2"
          :items="lists[rancho]"
          :pagination.sync="pagination"
          class="elevation-1"
        >
          <template v-slot:items="props" class="old">
            <tr :class="props.item.new">
              <td>{{ props.item.nave }}</td>
              <td>{{ props.item.sector }}</td>
              <td>
                <input
                  v-model="props.item['CE arriba']"
                  class="text-xs-center"
                  type="number"
                  step="0.1"
                />
              </td>
              <td>
                <input
                  v-model="props.item['CE medio']"
                  class="text-xs-center"
                  type="number"
                  step="0.1"
                />
              </td>
              <td>
                <input
                  v-model="props.item['CE abajo']"
                  class="text-xs-center"
                  type="number"
                  step="0.1"
                />
              </td>
              <td>
                <input
                  v-model="props.item['pH arriba']"
                  class="text-xs-center"
                  type="number"
                  step="0.1"
                />
              </td>
              <td>
                <input
                  v-model="props.item['pH medio']"
                  class="text-xs-center"
                  type="number"
                  step="0.1"
                />
              </td>
              <td>
                <input
                  v-model="props.item['pH abajo']"
                  class="text-xs-center"
                  type="number"
                  step="0.1"
                />
              </td>
              <td>
                <v-btn color="blue" fab small dark @click="add(props)">
                  +
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>

        <div class="text-xs-right">
          <v-btn color="success" @click="submitReport()">Enviar</v-btn>
        </div>
      </v-card>
    </v-dialog>

    <v-card>
      <h3>Reporte de Hoy</h3>
      <v-data-table
        v-if="!dialog"
        disable-initial-sort
        :headers="headers"
        :items="entry"
        :pagination.sync="pagination"
        class="elevation-1"
      >
        <template v-slot:items="props">
          <td>{{ props.item.nave }}</td>
          <td class="text-xs-right">{{ props.item["CE arriba"] }}</td>
          <td class="text-xs-right">{{ props.item["CE medio"] }}</td>
          <td class="text-xs-right">{{ props.item["CE abajo"] }}</td>
          <td class="text-xs-right">{{ props.item["pH arriba"] }}</td>
          <td class="text-xs-right">{{ props.item["pH medio"] }}</td>
          <td class="text-xs-right">{{ props.item["pH abajo"] }}</td>
          <td class="text-xs-right">
            {{ new Date(props.item.createdAt).toLocaleString() }}
          </td>
          <td class="justify-center layout px-0">
            <v-icon small @click="deleteItem(props.item)">delete</v-icon>
          </td>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
export default {
  data: () => ({
    subprojects: [
      "Andromeda",
      "Aquila",
      "Argus",
      "Aries",
      "Perseo",
      "Aurora",
      "ID",
      "Banco Madre",
    ],
    lists: {
    Andromeda: [
      {
        nave: "Andromeda 1 V.1",
        sector: 1,
      },
      {
        nave: "Andromeda 1 V.2",
        sector: 2,
      },
      {
        nave: "Andromeda 1 V.3",
        sector: 3,
      },
      {
        nave: "Andromeda 1 V.4",
        sector: 4,
      },
      // {
      //   nave: "Andromeda 2 V.1",
      //   sector: 5,
      // },
      // {
      //   nave: "Andromeda 3 V.2",
      //   sector: 6,
      // },
      {
        nave: "Andromeda 4 V.1",
        sector: 7,
      },
      {
        nave: "Andromeda 4 V.2",
        sector: 7,
      },

      {
        nave: "Andromeda 6 V.1",
        sector: 9,
      },
      {
        nave: "Andromeda 6 V.2",
        sector: 9,
      },
      {
        nave: "Andromeda 6 V.3",
        sector: 9,
      },
      {
        nave: "Andromeda 7 V.1",
        sector: 10,
      },
      {
        nave: "Andromeda 7 V.2",
        sector: 10,
      },
      {
        nave: "Andromeda 7 V.3",
        sector: 10,
      },
      {
        nave: "Andromeda 8 V.1",
        sector: 11,
      },
      {
        nave: "Andromeda 8 V.2",
        sector: 11,
      },
      {
        nave: "Andromeda 8 V.3",
        sector: 11,
      },
      
    ],
    Aquila: [
      {
        nave: "Aquila 1 V.1 LADO SUR",
        sector: 1,
      },
      {
        nave: "Aquila 1 V.2 LADO SUR",
        sector: 2,
      },
      {
        nave: "Aquila 1 V.3 LADO NORTE",
        sector: 3,
      },
      {
        nave: "Aquila 1 V.4 LADO NORTE",
        sector: 4,
      },
      {
        nave: "Aquila 2 V.1 LADO SUR",
        sector: 5,
      },
      {
        nave: "Aquila 2 V.2 LADO SUR",
        sector: 6,
      },
      {
        nave: "Aquila 2 V.3 LADO NORTE",
        sector: 7,
      },
      {
        nave: "Aquila 2 V.4 LADO NORTE",
        sector: 8,
      },
      {
        nave: "Aquila 3 V.1",
        sector: 9,
      },
      {
        nave: "Aquila 3 V.2",
        sector: 10,
      },
      {
        nave: "Aquila 4 V.1",
        sector: 11,
      },
      {
        nave: "Aquila 4 V.2",
        sector: 12,
      },
      {
        nave: "Aquila 4 V.3",
        sector: 13,
      },
      {
        nave: "Aquila 5 V.1",
        sector: 14,
      },
      {
        nave: "Aquila 5 V.2",
        sector: 14,
      },
      {
        nave: "Aquila 5 V.",
        sector: 14,
      },
      {
        nave: "Aquila 6 V.1",
        sector: 14,
      },
      {
        nave: "Aquila 7 V.3",
        sector: 15,
      },
      {
        nave: "Aquila 8 V.1",
        sector: 15,
      },
      {
        nave: "Aquila 8 V.2",
        sector: 16,
      },
      {
        nave: "Aquila 8 V.3",
        sector: 17,
      },
      {
        nave: "Aquila 9 V.1",
        sector: 18,
      },
      {
        nave: "Aquila 9 V.2",
        sector: 19,
      },
      {
        nave: "Aquila 9 V.3",
        sector: 20,
      },
      {
        nave: "Aquila 10 V.1",
        sector: 21,
      },
      {
        nave: "Aquila 10 V.2",
        sector: 22,
      },
      {
        nave: "Aquila 10 V.3",
        sector: 23,
      },
      {
        nave: "Aquila 11 V.1",
        sector: 24,
      },
      {
        nave: "Aquila 11 V.2",
        sector: 25,
      },
      {
        nave: "Aquila 11 V.3",
        sector: 26,
      },
      {
        nave: "Aquila 12 V.1",
        sector: 27,
      },
      {
        nave: "Aquila 12 V.2",
        sector: 28,
      },
      {
        nave: "Aquila 12 V.3",
        sector: 29,
      },
    ],
      Argus: [
        {
          nave: "Argus 4",
          sector: 1,
          new: false,
        },

        {
          nave: "Argus 12",
          sector: 2,
          new: false,
        },

        {
          nave: "Argus 3",
          sector: 3,
          new: false,
        },

        {
          nave: "Argus 10",
          sector: 4,
          new: false,
        },

        {
          nave: "Argus 2",
          sector: 5,
          new: false,
        },

        {
          nave: "Argus 6",
          sector: 6,
          new: false,
        },

        {
          nave: "Argus 6.1",
          sector: 6,
          new: false,
        },

        {
          nave: "Argus 1",
          sector: 7,
          new: false,
        },

        {
          nave: "Per 1 (Argus)",
          sector: 8,
          new: false,
        },
      ],
      Aries: [
        {
          nave: "Aries 1",
          sector: 1,
          new: false,
        },

        {
          nave: "Aries 2",
          sector: 2,
          new: false,
        },

        {
          nave: "Aries 3",
          sector: 3,
          new: false,
        },

        {
          nave: "Aries 4",
          sector: 4,
          new: false,
        },

        {
          nave: "Aries 5",
          sector: 5,
          new: false,
        },

        {
          nave: "Aries 6",
          sector: 6,
          new: false,
        },

        {
          nave: "Aries 7",
          sector: 7,
          new: false,
        },
      ],
      Perseo: [
        {
          nave: "Perseo Acodos",
          sector: 2,
          new: false,
        },
        {
          nave: "Perseo Nodriza",
          sector: 1,
          new: false,
        },
        {
          nave: "Perseo Semillero",
          sector: 3,
          new: false,
        },
        {
          nave: "Perseo SemilleroB",
          sector: 5,
          new: false,
        },
        {
          nave: "Perseo EngordaA",
          sector: 1,
          new: false,
        },
        {
          nave: "Perseo EngordaB",
          sector: 2,
          new: false,
        },
        {
          nave: "Perseo Engorda21A",
          sector: 3,
          new: false,
        },
        {
          nave: "Perseo Engorda21B",
          sector: 4,
          new: false,
        },
        {
          nave: "Perseo Banco 28lts",
          sector: 1,
          new: false,
        },
        {
          nave: "Perseo Banco 165lts",
          sector: 2,
          new: false,
        },
      ],
      Aurora: [
        {
          nave: "Aurora 1",
          sector: 1,
          new: false,
        },
        {
          nave: "Aurora 2",
          sector: 2,
          new: false,
        },
        {
          nave: "Aurora 3",
          sector: 3,
          new: false,
        },
        {
          nave: "Aurora 4",
          sector: 4,
          new: false,
        },
        {
          nave: "Aurora 5",
          sector: 5,
          new: false,
        },
        {
          nave: "Aurora 6",
          sector: 6,
          new: false,
        },
        {
          nave: "Aurora 7",
          sector: 7,
          new: false,
        },
        {
          nave: "Aurora 8",
          sector: 8,
          new: false,
        },
        {
          nave: "Aurora 8.1",
          sector: 8,
          new: false,
        },
        {
          nave: "Aurora 9",
          sector: 9,
          new: false,
        },
        {
          nave: "Aurora 10",
          sector: 10,
          new: false,
        },
        {
          nave: "Aurora 11",
          sector: 11,
          new: false,
        },
        {
          nave: "Aurora 12",
          sector: 12,
          new: false,
        },
      ],
      ID: [
        {
          nave: "ID 1",
          sector: 1,
          new: false,
        },
        {
          nave: "ID 2",
          sector: 2,
          new: false,
        },
        {
          nave: "ID 3",
          sector: 3,
          new: false,
        },
        {
          nave: "ID 4",
          sector: 4,
          new: false,
        },
        {
          nave: "ID 5",
          sector: 5,
          new: false,
        },
      ],
      "Banco Madre": [
        {
          nave: "Banco AND1 LADO NORTE V1",
          sector: 1,
        },
        {
          nave: "Banco AND1 LADO SUR V4",
          sector: 2,
        },
        {
          nave: "BANCO AQ2 LADO NORTE V3",
          sector: 3,
        },
        {
          nave: "BANCO AQ2 LADO SUR V1",
          sector: 4,
        },
      ],
    },
    items: [],
    pagination: {
      page: 1,
      rowsPerPage: 60,
    },
    dialog: false,
    headers: [
      {
        text: "Nave",
        // , align: 'right'
        sortable: false,
        value: "nave",
      },
      { text: "Sector", value: "sector", align: " d-none" },
      { text: "CE arriba", value: "CE arriba", align: "right" },
      { text: "CE medio", value: "CE medio", align: "right" },
      { text: "CE abajo", value: "CE abajo", align: "right" },
      { text: "pH arriba", value: "pH arriba", align: "right" },
      { text: "pH medio ", value: "pH medio ", align: "right" },
      { text: "pH abajo", value: "pH abajo", align: "right" },
      { text: "Fecha", value: "createdAt", align: "center" },
      { text: "Eliminar", value: "name", sortable: false, align: "center" },
    ],
    headers2: [
      {
        text: "Nave",
        // align: 'left',
        sortable: false,
        value: "nave",
      },
      { text: "Sector", value: "sector" },
      { text: "CE arriba", value: "CE arriba" },
      { text: "CE medio", value: "CE medio" },
      { text: "CE abajo", value: "CE abajo" },
      { text: "pH arriba", value: "pH arriba" },
      { text: "pH medio ", value: "pH medio " },
      { text: "pH abajo", value: "pH abajo" },
      { text: "Agregar", value: "name", sortable: false },
    ],
    rancho: null,
    valid: true,
    entry: [],
    editedIndex: -1,
    editedItem: {
      // variedad: 'Biloxil'
    },
    defaultItem: {},
    dialog: false,
  }),
  computed: {
    formTitle() {
      return "Reporte Diario";
    },
    rancho() {
      return this.rancho;
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    rancho() {
      this.new();
    },
  },
  created() {
    this.new();
  },
  methods: {
    new() {
      this.$axios
        .get("/api/VarillaReports/", this.editedItem)
        .then((response) => {
          console.log("resp", response);
          this.entry = response.data;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    selectSubproject: async function(event) {
      this.rancho = event;
      this.dialog = true;
    },
    add(event) {
      let index = event.index;
      let item = { ...event.item };

      item.new = true;
      item["CE arriba"] = null;
      item["CE medio"] = null;
      item["CE abajo"] = null;
      item["pH arriba"] = null;
      item["pH medio"] = null;
      item["pH abajo"] = null;

      console.log(item);

      this.lists[this.rancho].insert = function(index, item) {
        this.splice(index, 0, item);
      };
      this.lists[this.rancho].insert(index, item);
    },
    submitReport(props) {
      console.log(this.lists[this.rancho]);

      this.$axios
        .post("/api/VarillaReportsAll/", this.lists[this.rancho])
        .then((response) => {
          // if (response.status === 204) {
          //   // this.items.splice(props.index, 1);
          //   alert("Registro enviado!!!");
          //   this.dialog = false;
          //   this.new();
          // } else {
          //   alert("ERROR");
          // }
        })
        .catch((e) => {
          console.log(e);
        });
      this.dialog = false;
      this.new();
    },
    deleteItem(item) {
      const index = this.entry.indexOf(item);
      const _id = {
        _id: this.entry[this.entry.indexOf(item)]._id,
      };
      let r = confirm("¿Estas seguro que quieres eliminar este registro?");
      if (r == true) {
        this.entry.splice(index, 1);
        this.$axios.post("/api/DeleteVarillaReports/", _id);
      }
    },
    close() {
      this.dialog = false;
      this.rancho = null;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
  },
};
</script>

<style scoped>
.v-card {
  padding: 2% !important;
}

.old:hover {
  border: 1px solid blue !important;
}

.true {
  background-color: black !important;
}

input {
  background-color: rgba(190, 190, 190, 0.1);
  display: block !important;
  border: 0.5px solid lightgray !important;
  border-radius: 3px;
  padding: 8px;
  width: 110px;
}
</style>
